import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { BlueMediaResponse, PolicyPayment, SystemFile } from '../../../domain/common.model';
import { InterceptorHttpParams } from '../../../domain/interceptor.model';
import { IOfferToken, IssuanceDataHolder } from '../../../domain/ioffer.domain';
import { Offer } from '../../../domain/offer.domain';
import { GenericService } from './generic.service';
import { UtilsService } from './utils.service';


@Injectable()
export class IOfferService extends GenericService {
    constructor(private store: Store,
                private http: HttpClient) {
        super(store);
    }

    checkToken(token: string) {
        return this.http.get<any>(`/api/public/ioffer/check/${token}`);
    }

    getOfferToken(token: string, pesel: string) {
        const params = UtilsService.buildQueryParams({token, pesel});
        return this.http.get<IOfferToken>(`/api/public/ioffer/token`, {params});
    }

    getOffer(token: string) {
        const headers = new HttpHeaders().append('iOffer-Token', token);
        return this.http.get<Offer>(`/api/public/ioffer/offer`, {headers});
    }

    acceptOffer(token: string) {
        const headers = new HttpHeaders().append('iOffer-Token', token);
        return this.http.put<IssuanceDataHolder>(`/api/public/ioffer/offer/accept`, {}, {headers});
    }

    cancelOffer(token: string) {
        const headers = new HttpHeaders().append('iOffer-Token', token);
        return this.http.put<any>(`/api/public/ioffer/offer/cancel`, {}, {headers});
    }

    printoutOffer(token: string, id: number, productId: number, all: boolean) {
        const headers = new HttpHeaders().append('iOffer-Token', token);
        return all
            ? this.http.get<SystemFile>(`/api/public/ioffer/offer/print/${productId}/all`, {headers})
            : this.http.get<SystemFile>(`/api/public/ioffer/offer/print/${productId}`, {headers});
    }

    printPolicy(token: string, policyId: number, all: boolean) {
        const headers = new HttpHeaders().append('iOffer-Token', token);
        return all
            ? this.http.get<SystemFile>(`/api/public/ioffer/policy/${policyId}/print/policy/all`, {headers})
            : this.http.get<SystemFile>(`/api/public/ioffer/policy/${policyId}/print/policy`, {headers});
    }

    printSummary(token: string, policyId: number) {
        const headers = new HttpHeaders().append('iOffer-Token', token);
        return this.http.get<SystemFile>(`/api/public/ioffer/policy/${policyId}/print/summary`, {headers})
    }

    payPolicy(token: string, orderId: string) {
        const headers = new HttpHeaders().append('iOffer-Token', token);
        return this.http.post<BlueMediaResponse>(`/api/public/ioffer/policy/${orderId}/pay`, {}, {headers});
    }

    checkPaymentStatus(token: string) {
        const params = new InterceptorHttpParams(false);
        return this.http.get<PolicyPayment>(`/api/public/bm/status/${token}`, {params});
    }
}
